// @ts-check
// =============================================================================
// js/ui/card-order.js — the collection/deck display sort.
//
// ORDER (requested grouping, built on the old server's card index):
//   free creatures · free events · crop creatures · crop events ·
//   meat creatures · meat events · egg/wait creatures
//
// i.e. the SORT PRIORITY is:
//   1. cost TYPE:      free(0) < crop(1) < meat(2) < wait(3)   (dominant cost)
//   2. creature/event: creatures before events                (within a type)
//   3. cost AMOUNT:    ascending                               (within a group)
//   4. tiebreakers:    extra tick cost, then id/name — mirroring the old
//      server's index (Old Deckbiter/server.js:632, which summed
//      cropCost·1e5 + meatCost·1e7 + waitCost·1e9 + event·1e4 + extraTick·1e3
//      + id). We keep those same tiebreak fields; the only change from the old
//      formula is promoting the event flag above the cost amount so creatures
//      and events form separate blocks instead of interleaving by cost.
//
// The pool/collection comparator drops the id term and tiebreaks on NAME (the
// old client's pool behavior); the deck list keeps the full value (id tiebreak).
// =============================================================================

/** Dominant cost type: 0 free · 1 crop · 2 meat · 3 wait. */
function typeRank(card) {
	if (card.waitCost) return 3;
	if (card.meatCost) return 2;
	if (card.cropCost) return 1;
	return 0;
}

/** The card's cost in its dominant type (0 for free). */
function costAmount(card) {
	return card.waitCost || card.meatCost || card.cropCost || 0;
}

/**
 * The per-card sort index: type, then creature-vs-event, then cost amount, then
 * the old tiebreakers (extra tick cost, id).
 * @param {any} card  A card DEFINITION.
 * @returns {number}
 */
export function cardSortValue(card) {
	return typeRank(card) * 1e14
		+ (card.event ? 1 : 0) * 1e12
		+ costAmount(card) * 1e8
		+ (card.extraTickCost || 0) * 1e4
		+ (card.id || 0);
}

/**
 * Comparator for the collection / deck-pool grid: the ordering above, with NAME
 * as the final tiebreak instead of id (old client pool behavior). Egg (id 0)
 * first.
 * @param {any} a
 * @param {any} b
 * @returns {number}
 */
export function compareCardsForDisplay(a, b) {
	if (a.id === 0) return -1;
	if (b.id === 0) return 1;
	const diff = (cardSortValue(a) - (a.id || 0)) - (cardSortValue(b) - (b.id || 0));
	if (diff !== 0) return diff;
	return String(a.name || '').localeCompare(String(b.name || ''));
}
